import { AxiosResponse } from 'axios';
import {
	UserGroup,
	CreateUserGroupInput,
	UpdateUserGroupInput,
	AddMembersToUserGroupInput,
	RemoveMembersFromUserGroupInput,
	UserGroupFilter,
} from '../data/models/userGroup';
import axiosClient from '../clients/axios-client';
import { stringifyReqObj } from '../utils/common-utils';

const userGroupROGraphQL = `
	id
	created
	updated
	name
	description
	users
	externalUsers
`;

export async function getUserGroups(
	filter: UserGroupFilter = {}
): Promise<{ list: UserGroup[]; count: number }> {
	const graphqlQuery = `
		{
			userGroups(
				filter: ${stringifyReqObj(filter)},
			) {
				list {
					${userGroupROGraphQL}
				}
				count
			}
		}
	`;

	const response: AxiosResponse = await axiosClient({
		url: 'graphql',
		method: 'POST',
		data: {
			query: graphqlQuery,
		},
	});

	return response?.data?.userGroups;
}

export async function getUserGroup(id: string): Promise<UserGroup> {
	const graphqlQuery = `
		{
			userGroup(id: "${id}") {
				${userGroupROGraphQL}
			}
		}
	`;

	const response: AxiosResponse = await axiosClient({
		url: 'graphql',
		method: 'POST',
		data: {
			query: graphqlQuery,
		},
	});

	return response?.data?.userGroup;
}

export async function createUserGroup(
	input: CreateUserGroupInput
): Promise<UserGroup> {
	const graphqlQuery = `
		mutation {
			createUserGroup(input: ${stringifyReqObj(input)}) {
				${userGroupROGraphQL}
			}
		}
	`;

	const response: AxiosResponse = await axiosClient({
		url: 'graphql',
		method: 'POST',
		data: {
			query: graphqlQuery,
		},
	});

	return response?.data?.createUserGroup;
}

export async function updateUserGroup(
	id: string,
	input: UpdateUserGroupInput
): Promise<UserGroup> {
	const graphqlQuery = `
		mutation {
			updateUserGroup(id: "${id}", input: ${stringifyReqObj(input)}) {
				${userGroupROGraphQL}
			}
		}
	`;

	const response: AxiosResponse = await axiosClient({
		url: 'graphql',
		method: 'POST',
		data: {
			query: graphqlQuery,
		},
	});

	return response?.data?.updateUserGroup;
}

export async function deleteUserGroup(id: string): Promise<boolean> {
	const graphqlQuery = `
		mutation {
			deleteUserGroup(id: "${id}")
		}
	`;

	const response: AxiosResponse = await axiosClient({
		url: 'graphql',
		method: 'POST',
		data: {
			query: graphqlQuery,
		},
	});

	return response?.data?.deleteUserGroup;
}

export async function addMembersToUserGroup(
	id: string,
	input: AddMembersToUserGroupInput
): Promise<UserGroup> {
	const graphqlQuery = `
		mutation {
			addMembersToUserGroup(id: "${id}", input: ${stringifyReqObj(input)}) {
				${userGroupROGraphQL}
			}
		}
	`;

	const response: AxiosResponse = await axiosClient({
		url: 'graphql',
		method: 'POST',
		data: {
			query: graphqlQuery,
		},
	});

	return response?.data?.addMembersToUserGroup;
}

export async function removeMembersFromUserGroup(
	id: string,
	input: RemoveMembersFromUserGroupInput
): Promise<UserGroup> {
	const graphqlQuery = `
		mutation {
			removeMembersFromUserGroup(id: "${id}", input: ${stringifyReqObj(input)}) {
				${userGroupROGraphQL}
			}
		}
	`;

	const response: AxiosResponse = await axiosClient({
		url: 'graphql',
		method: 'POST',
		data: {
			query: graphqlQuery,
		},
	});

	return response?.data?.removeMembersFromUserGroup;
}
